export function encodePercentageCharacter(uri) {

    /** TODO regex below needs to be adapted with accents **/
    if (uri.length === 0) {
        return uri;
    }

    return uri.replace(/(\\)?%(?![0-9][0-9a-fA-F]+)/g, '%5C%25');
}